import styles from './HeaderCellWrapper.module.scss';

import React, { PropsWithChildren } from 'react';

export const HeaderCellWrapper: React.FC<PropsWithChildren<unknown>> = (
  props
) => {
  return <div className={styles.wrapper} {...props} />;
};
